export default __webpack_public_path__ + "static/media/11.c92e4aa4.jpg";